import React from 'react';
import '../template-file-css/document-file-template.css';

export const GENERAL_PhysicalHealthStandard = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='GENERAL_PhysicalHealthStandard' className='file-pdf-document'>
            <div className='file-template'>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>SERVICE TYPE:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type="checkbox" name="chkRequest" id="chkRequest" className='add-only' value="Request1" />PSYCHOLOGICAL / NEUROPSYCHOLOGICAL
                        </td>
                        <td className='w-350'>
                            <input type="checkbox" name="chkRequest1" id="chkRequest1" className='add-only' value="Request2" />APPLIED BEHAVIOR ANALYSIS (ABA)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" name="chkRequest2" id="chkRequest2" className='add-only' value="Request3" />ELECTROCONVULSIVE THERAPY (ECT) / TRANSCRANIAL MAGNETIC STIMULATION (TMS)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type="checkbox" name="chkRequest3" id="chkRequest3" className='add-only' value="Request4" />OUTPATIENT TREATMENT REQUEST (OTR)
                        </td>
                        <td className='w-350'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" name="chkRequest4" id="chkRequest4" className='add-only' value="Request5" />URGENT - When a non-urgent prior authorization request could seriously jeopardize the life or health of a &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;member. The member's
                            ability to attain, maintain, or regain maximum function or that a delay in treatment &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;would subject the member to severe pain that
                            could not be adequately managed without the care/service &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;requested. Urgent requests will be processed within 72 hours.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" name="chkRequest5" id="chkRequest5" className='add-only' value="Request6" />NON - URGENT STANDARD - Routine services processed within 14 business days.
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    Visit our ProPAT search tool to determine if a service requested requires PA ( insert web address).
                </p>
                <p className='w-750'>
                    A determination will be communication to the requesting provider.
                </p>
                <h4>COMPLETE SECTIONS 1 -3 IN THEIR ENTIRETY.
                </h4>
                <h4>SECTION 1 - MEMBER INFORMATION
                </h4>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>1. FIRST NAME</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>2. M.I.</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>3. LAST NAME</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtFirstName" name="txtFirstName" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtMi" name="txtMi" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtLastName" name="txtLastName" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>4. MEDICAID ID#</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>5. DATE OF BIRTH</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>6. MEMBER PHONE #</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtFirstName2" name="txtFirstName2" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="date" id="txtMi2" name="txtMi" className='add-only' placeholder="(MMDDYYYY)" />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtLastName21" name="txtLastName21" placeholder="(xxx-xxx-xxxx)" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>7. DOES THE MEMBER HAVE OTHER INSURANCE?</span><span className='small'>(Include PolicyNumber Below)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rbInsurance_Yes" name="rbInsurance" className='add-only' value="1" />   Yes
                            <input type="radio" id="rbInsurance_No" name="rbInsurance" className='add-only' value="0" />   No
                            <input type="text" id="txtInsurance" name="txtInsurance" className='add-only' />
                        </td>
                    </tr>
                </table>

                <h4>SECTION 2 ORDERING/REFERRING & SERVICING PROVIDER INFORMATION
                </h4>
                <table>
                    <tr>
                        <td className='w-350'>
                            <span className='eleHeader'>8. ORDERING/REFERRING PROVIDER NAME</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>9. CONTACT PERSON </span><span className='small'>(For questions)</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>10. TELEPHONE #</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'>
                            <input type="text" id="txtFirstName1" name="txtFirstName1" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtMi1" name="txtMi1" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtLastName2" name="txtLastName2" placeholder="(xxx-xxx-xxxx)" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'>
                            <span className='eleHeader'>11. FAX #</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>12. NPI</span>
                        </td>
                        <td className='w-200'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'>
                            <input type="text" id="txtFax" name="txtFax" placeholder="(xxx-xxx-xxxx)" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtNpi" name="txtNpi" className='add-only' />
                        </td>
                        <td className='w-200'>&nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-400'>
                            <span className='eleHeader'>13. SERVICING PROVIDER NAME / FACILITY / AGENCY</span>
                        </td>
                        <td className='w-175'>
                            <span className='eleHeader'>14. CONTACT PERSON</span><span className='small'>(For questions)</span>
                        </td>
                        <td className='w-175'>
                            <span className='eleHeader'>15. TELEPHONE #</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type="text" id="txtFirstName3" name="txtFirstName3" className='add-only' />
                        </td>
                        <td className='w-175'>
                            <input type="text" id="txtMi3" name="txtMi3" className='add-only' />
                        </td>
                        <td className='w-175'>
                            <input type="text" id="txtLastName3" name="txtLastName3" placeholder="(xxx-xxx-xxxx)" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-400'>
                            <span className='eleHeader'>16. FAX #</span>
                        </td>
                        <td className='w-175'>
                            <span className='eleHeader'>17. NPI</span>
                        </td>
                        <td className='w-175'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type="text" id="txtFax1" name="txtFax1" placeholder="(xxx-xxx-xxxx)" className='add-only' />
                        </td>
                        <td className='w-175'>
                            <input type="text" id="txtNpi1" name="txtNpi1" className='add-only' />
                        </td>
                        <td className='w-175'>&nbsp;
                        </td>
                    </tr>
                </table>
                <h4>SECTION 3 - DIAGNOSIS CODES AND SERVICE / HCPCS CODES
                </h4>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>18. SERVICE START DATE</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>19. SERVICE END DATE</span>
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="date" id="txtStartDate" name="txtStartDate" placeholder="(MMDDYYYY)" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="date" id="txtEndDate" name="txtEndDate" className='add-only' placeholder="(MMDDYYYY)" />
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>20. ICD 10 / DSM 5 CODE(S)</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>21. CODE DESCRIPTION(S)</span> <span className='small'>Include description of the service when uncertain of a code.</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtDsmCode" name="txtDsmCode" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtCodeDisc" name="txtCodeDisc" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtDsmCode1" name="txtDsmCode1" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtCodeDisc1" name="txtCodeDisc1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtDsmCode2" name="txtDsmCode2" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtCodeDisc2" name="txtCodeDisc2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtDsmCode3" name="txtDsmCode3" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtCodeDisc3" name="txtCodeDisc3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtDsmCode4" name="txtDsmCode4" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtCodeDisc4" name="txtCodeDisc4" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtDsmCode5" name="txtDsmCode5" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtCodeDisc5" name="txtCodeDisc5" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtDsmCode6" name="txtDsmCode6" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtCodeDisc6" name="txtCodeDisc6" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtDsmCode7" name="txtDsmCode7" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtCodeDisc7" name="txtCodeDisc7" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>21. CPT / HCPCS / REV CODES:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>22. CODE DESCRIPTION(S):</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>23. QUANTITY / UNITS:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtCpt" name="txtCpt" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txCodeRev" name="txCodeRev" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtQuantity" name="txtQuantity" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtCpt1" name="txtCpt1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txCodeRev1" name="txCodeRev1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtQuantity1" name="txtQuantity1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtCpt2" name="txtCpt2" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txCodeRev2" name="txCodeRev2" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtQuantity2" name="txtQuantity2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtCpt3" name="txtCpt3" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txCodeRev3" name="txCodeRev3" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtQuantity3" name="txtQuantity3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtCpt4" name="txtCpt4" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txCodeRev4" name="txCodeRev4" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtQuantity4" name="txtQuantity4" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtCpt5" name="txtCpt5" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txCodeRev5" name="txCodeRev5" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtQuantity5" name="txtQuantity5" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtCpt6" name="txtCpt6" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txCodeRev6" name="txCodeRev6" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtQuantity6" name="txtQuantity6" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtCpt7" name="txtCpt7" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txCodeRev7" name="txCodeRev7" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtQuantity7" name="txtQuantity7" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtCpt8" name="txtCpt8" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txCodeRev8" name="txCodeRev8" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtQuantity8" name="txtQuantity8" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtCpt9" name="txtCpt9" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txCodeRev9" name="txCodeRev9" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtQuantity9" name="txtQuantity9" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h3>COMPLETE THE SECTION WHICH CORRESPONDS TO THE SERVICE AUTHORIZATION BEING REQUESTED.
                </h3>
                <h4>NOTE: SECTION 8 "ATTESTATION" MUST BE COMPLETED FOR ALL REQUESTS
                </h4>
                <h4>SECTION 4 - ECT / TMS REQUEST<span className='small'>Complete all fields in their entirety.</span>
                </h4>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>24. TREATMENT REQUEST FOR:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>25. PLACE OF SERVICE</span> <span className='small'>(If inpatient, why?):</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="radio" id="rbMedicationHas_Yes" name="rbMedicationHas" className='add-only' value="1" /> Initial &nbsp; &nbsp;
                            <input type="radio" id="rbMedicationHas_No" name="rbMedicationHas" className='add-only' value="0" />  Concurrent
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtPlaceService" name="txtPlaceService" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>26. PRIOR ECT TREATMENT?</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>27. INFORMATION CONSENT OBTAINED?</span> <span className='small'>(If applicable):</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="radio" id="rbMedicationHas1_Yes" name="rbMedicationHas1" className='add-only' value="1" /> Yes &nbsp;
                            <input type="radio" id="rbMedicationHas1_No" name="rbMedicationHas1" className='add-only' value="0" />  No
                        </td>
                        <td className='w-375'>
                            <input type="radio" id="rbMedicationHas2_Yes" name="rbMedicationHas2" className='add-only' value="1" /> Yes &nbsp;
                            <input type="radio" id="rbMedicationHas2_No" name="rbMedicationHas2" className='add-only' value="0" />  No
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>28. SUBSTANCE ABUSE HISTORY?</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>29. ATTENDING PYSCHOTHERAPY?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="radio" id="rbMedicationHas3_Yes" name="rbMedicationHas3" className='add-only' value="1" /> Yes &nbsp;
                            <input type="radio" id="rbMedicationHas3_No" name="rbMedicationHas3" className='add-only' value="0" />  No
                        </td>
                        <td className='w-375'>
                            <input type="radio" id="rbMedicationHas4_Yes" name="rbMedicationHas4" className='add-only' value="1" /> Yes &nbsp;
                            Frequency: <input type="text" id="txtFrequency" name="txtFrequency" className='add-only w-150 custom-add-only' /> &nbsp;
                            <input type="radio" id="rbMedicationHas4_No" name="rbMedicationHas4" className='add-only' value="0" />  No
                        </td>
                    </tr>
                </table>



                <p className='w-750'>
                    <span className='eleHeader'>30. KNOWN SEIZURE HISTORY / CONTRAINDICATIONS TO ECT?</span>
                    <textarea id="txtSeizure1" name="txtSeizure1" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>31. KNOWN REACTION TO ANESTHESIA, OR MEDICAL COMPLICATION TO ECT?</span>
                    <textarea id="txtSeizure2" name="txtSeizure2" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>32. TARGET SYMPTOMS?</span>
                    <textarea id="txtSeizure3" name="txtSeizure3" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>33. AREAS OF CONCERN </span><span className='small'>(Select all that apply)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" name="chkPresence1" id="chkPresence1" className='add-only' value="Presence1" />Presence of cognitive disorder
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" name="chkPresence2" id="chkPresence2" className='add-only' value="Presence2" />Presence of significant personality disorder
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" name="chkPresence3" id="chkPresence3" className='add-only' value="Presence3" />Lack of housing or family/social support
                            for transition from IP ECT to OP ECT
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h4>Include the following clinical documentation with the ECT/TMS Prior Authorization Request:
                    </h4>
                </p>
                <p className='w-750'>
                    <ul>
                        <li>Recent comprehensive Psychiatric Evaluation
                        </li>
                        <li>History of Psychiatric Treatment to date (include all levels of care)
                            <ul>
                                <li>Include onset, course, and severity of illness
                                </li>
                                <li>Response to treatment
                                </li>
                                <li>Describe Patient's overall treatment compliance
                                </li>
                            </ul>
                        </li>
                        <li>For prior ECT treatment, include dates, location, number of treatments, results and known contraindications to ECT
                        </li>
                        <li>Substance abuse history and current status
                        </li>
                        <li>Any labs/diagnostic tests available to the prescribing clinician
                        </li>
                    </ul>
                </p>
                <p className='w-750'>
                    <h4>SECTION 5 - PSYCHOLOGICAL / NEUROPSYCHOLOGICAL TESTING REQUEST
                        <span className='small'>Complete all fields in their entirety.</span>
                    </h4>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>34. SERVICE TYPE REQUESTED</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>35. PRIOR TESTING?</span> <span className='small'>(If yes, include date)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="radio" id="rbServiceType1_Yes" name="rbServiceType1" className='add-only' value="1" />  Psychological &nbsp;
                            <input type="radio" id="rbServiceType1_No" name="rbServiceType1" className='add-only' value="0" />  Neuropsychological
                        </td>
                        <td className='w-375'>
                            <input type="radio" id="rbServiceType2_Yes" name="rbServiceType2" className='add-only' value="1" /> Yes &nbsp;
                            DATE:<input type="date" id="txtDate" name="txtDate" placeholder="(MMDDYY)" className='add-only  w-200 custom-add-only' /> &nbsp;
                            <input type="radio" id="rbServiceType2_No" name="rbServiceType2" className='add-only' value="0" />  No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>36. CURRENT BH OUTPATIENT SERVICES?</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>37. PSYCHIATRIC DIAGNOSTIC EVALUATION?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="radio" id="rbServiceType3_Yes" name="rbServiceType3" className='add-only' value="1" /> Yes &nbsp;
                            <input type="radio" id="rbServiceType3_No" name="rbServiceType3" className='add-only' value="0" />  No
                        </td>
                        <td className='w-375'>
                            <input type="radio" id="rbServiceType4_Yes" name="rbServiceType4" className='add-only' value="1" /> Yes &nbsp;
                            <input type="radio" id="rbServiceType4_No" name="rbServiceType4" className='add-only' value="0" />  No
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>38. WHAT IS THE CLINICAL QUESTION TO BE ANSWERED BY TESTING?</span>
                    <textarea id="txtServiceType" name="txtServiceType" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>39. HOW WILL TESTING AFFECT MEMBER'S TREATMENT?</span>
                    <textarea id="txtServiceType1" name="txtServiceType1" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>40. DETAILED CLINICAL SUMMARY FROM TREATING PSYCHIATRIC PROVIDER FOR 6 MONTHS:</span>
                    <textarea id="txtServiceType2" name="txtServiceType2" className='add-only'></textarea>
                </p>
                <h4>Include the following documentation with the Psychological/Neuropsychological Prior Authorization Request:
                </h4>
                <ul>
                    <li>Detailed clinical summary (Physical & Behavioral Health)
                    </li>
                    <li>BHMP Evaluation & progress notes that detail assessment of clinical concern
                    </li>
                    <li>Any supporting rating scales
                    </li>
                    <li>Neurological assessment reviewed by BHMP (if request is for a Neuropsychological Evaluation)
                    </li>
                    <li>Any prior testing completed
                    </li>
                </ul>
                <h4>SECTION 6 - APPLIED BEHAVIORAL ANALYSIS (ABA)
                    <span className='small'>Complete all fields in their entirety.</span>
                </h4>
                <p className='w-750'>
                    <span className='eleHeader'>41. REQUEST TYPE?</span>
                    <input type="radio" id="rbConcurrent_Yes" name="rbConcurrent" className='add-only' value="1" /> Initial &nbsp;
                    <input type="radio" id="rbConcurrent_No" name="rbConcurrent" className='add-only' value="0" />  Concurrent
                </p>
                <p className='w-750'>
                    If concurrent, how long has member been receiving services?
                    <input type="text" id="txtInitial" name="txtInitial" className='add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>42. TREATMENT SETTING?</span>
                    <textarea id="txtTreatment1" name="txtTreatment1" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>43. CLINICAL SYMPTOMS OR SOCIAL BARRIERS?</span>
                    <textarea id="txtTreatment2" name="txtTreatment2" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>44. DISCHARGE PLAN</span><span className='small'>(Anticipated date to transition to lower level of care)</span>
                    <textarea id="txtTreatment3" name="txtTreatment3" className='add-only'></textarea>
                </p>
                <h4>SECTION 7 - OUTPATIENT TREATMENT REQUEST (OTR) REQUEST
                    <span className='small'>Complete all fields in their entirety.</span>
                </h4>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>45. REQUEST TYPE?</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>46. SERVICE TYPE?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="radio" id="rbServiceType5_Yes" name="rbServiceType5" className='add-only' value="1" /> Initial &nbsp;
                            <input type="radio" id="rbServiceType5_No" name="rbServiceType5" className='add-only' value="0" />  Concurrent
                        </td>
                        <td className='w-375'>
                            <input type="radio" id="rbServiceType6_Yes" name="rbServiceType6" className='add-only' value="1" />  Substance Use Order &nbsp;
                            <input type="radio" id="rbServiceType6_No" name="rbServiceType6" className='add-only' value="0" />  Mental Health
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>47. Clinical Symptoms or Social Barriers?</span>
                    <textarea id="txtClinical" name="txtClinical" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>48. Discharge Plan </span><span className='small'>(Anticipated date to transition to lower level of care):</span>
                    <textarea id="txtClinical1" name="txtClinical1" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>49. Substance Abuse and/or Mental Health History - History and Current Status:</span>
                    <textarea id="txtClinical2" name="txtClinical2" className='add-only'></textarea>
                </p>
                <h4>50. Criteria/Level of Care Utilized in Past 12 Months:
                </h4>
                <table>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>Criteria/Level of Care</span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>Name of Provider</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>Duration</span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>Approximate Dates</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Outcome</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtCriteria" name="txtCriteria" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtProviderName" name="txtProviderName" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtDuration" name="txtDuration" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtApproximateDates" placeholder="(MMDDYYYY- MMDDYYYY)" name="txtApproximateDates" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtOutcome" name="txtOutcome" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtCriteria1" name="txtCriteria1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtProviderName1" name="txtProviderName1" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtDuration1" name="txtDuration1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtApproximateDates1" placeholder="(MMDDYYYY- MMDDYYYY)" name="txtApproximateDates1" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtOutcome1" name="txtOutcome1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtCriteria2" name="txtCriteria2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtProviderName2" name="txtProviderName2" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtDuration2" name="txtDuration2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtApproximateDates2" placeholder="(MMDDYYYY- MMDDYYYY)" name="txtApproximateDates2" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtOutcome2" name="txtOutcome2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtCriteria3" name="txtCriteria3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtProviderName3" name="txtProviderName3" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtDuration3" name="txtDuration3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtApproximateDates3" placeholder="(MMDDYYYY- MMDDYYYY)" name="txtApproximateDates3" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtOutcome3" name="txtOutcome3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtCriteria4" name="txtCriteria4" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtProviderName4" name="txtProviderName4" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtDuration4" name="txtDuration4" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtApproximateDates4" placeholder="(MMDDYYYY- MMDDYYYY)" name="txtApproximateDates4" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtOutcome4" name="txtOutcome4" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>51. OPTIONAL SPACE FOR ADDITIONAL DOCUMENTATION:</span>
                    <textarea id="txtOptional" name="txtOptional" className='add-only'></textarea>
                </p>
                <h4>Include the following documentation with the ABA Request or OTR Prior Authorization Request:
                </h4>
                <ul>
                    <li>Clinical data (Psycho/Social/Behavioral history, mental status, current specific maladaptive behaviors and/or skill deficits, co-occurring
                        disorders, and medical condition(s)
                    </li>
                    <li>Progress reducing target behaviors/skill deficits or lackof, and plan to address . For initial ABA requests, include progress or lack-of,
                        with any previous treatment interventions
                    </li>
                    <li>Compliance with treatment and treatment recommendations, include plan to address non -compliance
                    </li>
                    <li>For ABA Requests, include treatment plan
                    </li>
                </ul>
                <h4>SECTION 8 - ATTESTATION
                    <span className='small'>Complete all fields in their entirety.</span>
                </h4>
                <table>
                    <tr>
                        <td className='signature w-550'>&nbsp;
                        </td>
                        <td className='signature w-200 '>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='small w-550'>52. Printed Name of Provider/Clinician:
                        </td>
                        <td className='small w-200'>53. Date (MMDDYYYY):
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='signature w-750'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='small w-750'>54. Signature of Provider/Clinician:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <strong>NOTE:</strong> This form must be completed in its entirety in order to receive a determination. Incomplete forms may lead to delays in
                    processing or lack of authorization.
                </p>
                <p className='w-750'>
                    <strong>AUTHORIZATION DOES NOT GUARANTEE PAYMENT. ALL AUTHORIZATIONS ARE SUBJECT TO MEMBER ELIGIBILITY ON THE
                        DATE OF SERVICE. TO ENSURE PROPER PAYMENT FOR SERVICES RENEDERED; PROVIDER/FACILITY MUST VERIFY
                        ELIGIBILITY ON THE DATE OF SERVICE.</strong>
                </p>






            </div>
        </form>

    )
}



